
export function serializeWithInfinity(value: number): number | 'Infinity' | '-Infinity' {
    return value === Infinity ? "Infinity" : value === -Infinity ? "-Infinity" : value
}

export function deserializeWithInfinity(value: number | 'Infinity' | '-Infinity' ): number {
        return value === "Infinity" ? Infinity : value === "-Infinity" ? -Infinity : value
}
